<template>
  <div :class="$style.wrap">
    <h3>筛选订单</h3>
    <p :class="$style.title">所属游戏</p>
    <div :class="$style.list" v-if="gameList">
      <span
        :class="gameActive === item.id && $style.active"
        v-for="item in gameList"
        @click="selectGame(item.id)"
        :key="item.id"
      >
        {{ item.name }}
      </span>
    </div>
    <p :class="$style.title">查询时段</p>
    <div :class="$style.list" v-if="timeList">
      <span
        :class="timeActive === item.id && $style.active"
        v-for="item in timeList"
        @click="selectTime(item.id)"
        :key="item.id"
      >
        {{ item.name }}
      </span>
    </div>
  </div>
</template>
<script>
import { getTypeList } from "@/http/invoice";
export default {
  name: "selectType",
  data() {
    return {
      timer: null,
      gameList: this.$ls.get("gameList") || [],
      timeList: this.$ls.get("timeList") || [],
      gameActive: null,
      timeActive: null
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    async getInfo() {
      if (this.gameList.length && this.timeList.length) {
        this.setSessionAcitve();
        return false;
      }
      let res = await getTypeList();
      if (res.data) {
        const { game_list, time_bucket } = res.data;
        this.gameList = game_list;
        this.timeList = time_bucket;
        this.$ls.set("gameList", this.gameList);
        this.$ls.set("timeList", this.timeList);
        this.setSessionAcitve();
      } else if (res.rcode === 6002) {
        this.timer = setTimeout(() => {
          this.$router.replace({
            path: this._anchor.invoiceRules.path
          });
        }, 3000);
      }
    },
    selectTime(id) {
      if (this.timeActive === id) {
        return false;
      }

      this.timeActive = id;
    },
    selectGame(id) {
      if (this.gameActive === id) {
        return false;
      }
      this.gameActive = id;
    },
    setActive() {
      this.$ls.set("timeActive", this.timeActive);
      this.$ls.set("gameActive", this.gameActive);
    },
    setSessionAcitve() {
      this.gameActive = this.$ls.get("gameActive") || this.gameList[0].id;
      this.timeActive = this.$ls.get("timeActive") || this.timeList[0].id;
      this.setActive();
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>
<style module lang="less">
.wrap {
  padding: 0 0.3rem;
  font-size: 0.24rem;
  .title {
    margin-bottom: 0.28rem;
  }
  .list {
    margin-bottom: 0.32rem;
    display: flex;
    flex-wrap: wrap;
    span {
      display: inline-block;
      background: #ededf1;
      padding: 0.1rem 0.15rem;
      border-radius: 8%;
      margin: 0 0.1rem 0.2rem 0.1rem;
    }
    .active {
      background: rgb(72, 213, 175);
      color: #fff;
    }
  }
}
</style>
